var _style, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSgd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:#ed2939}.st1{fill:#fff}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0 0h40v20H0V0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M0 20h40v20H0V20zM19 10.5c0 4.2-3.4 7.5-7.5 7.5S4 14.6 4 10.5 7.3 3 11.5 3 19 6.3 19 10.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M18.1 7.1l2.5.3s.1-.1.5 1.3c.4 1.2-.6 5.9-1.7 6.6-1.1.7-2.7 1.8-2.7 1.8L15 14.5l.7-4.3 2.4-3.1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14.3 3.4c-3.9 0-7.1 3.2-7.1 7.1s3.2 7.1 7.1 7.1 7.1-3.2 7.1-7.1-3.2-7.1-7.1-7.1zM9.7 8.6H11l.4-1.3.4 1.3h1.3l-1 .8.4 1.3-1-.8-1 .8.4-1.3-1.2-.8zm3.8 5.6l.4 1.3-1-.8-1 .8.4-1.3-1-.8h1.3l.4-1.3.4 1.3h1.3l-1.2.8zm.9-6.5l.4-1.3-1-.8h1.3l.4-1.3.4 1.3h1.3l-1 .8.4 1.3-1-.8-1.2.8zm4.1 6.5l.4 1.3-1-.8-1 .8.4-1.3-1-.8h1.3l.4-1.3.4 1.3h1.3l-1.2.8zm.9-4.3l-1 .8.4-1.3-1-.8h1.3l.4-1.3.4 1.3h1.3l-1 .8.4 1.3-1.2-.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSgd);
export default __webpack_public_path__ + "static/media/sgd.379e915f53b9dc6558875aad34d27217.svg";
export { ForwardRef as ReactComponent };